export enum FollowUpStudyRecommendationCode {
	Save = "SAVE",
	ReferToInvestigation = "REFER_TO_INVESTIGATION",
	ReferToPublicProsecution = "REFER_TO_PUBLIC_PROSECUTION",
	RequestCompletion = "REQUEST_COMPLETION",
	ReturnToSbaOversight = "RETURN_TO_SBA_OVERSIGHT",
}
